import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Card,
  CardMedia,
  Box,
  Menu,
  MenuItem,
  Drawer,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Link, withRouter } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import HomeIcon from "@material-ui/icons/ViewList";
import AccountIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import AccountIcon2 from "@material-ui/icons/AccountCircle";
import HelpIcon from "@material-ui/icons/Star";
import ExitToApp from "@material-ui/icons/ExitToApp";
import SupervisorAccount from "@material-ui/icons/RecentActors";
import BarChartIcon from "@material-ui/icons/BarChart";
import StorefrontIcon from "@material-ui/icons/Storefront";
import { withTranslation } from "react-i18next";

import AuthStorage from "../../utils/authStorage";
import ApiUser from "../../API/ApiUser";
import SmartsuppChat from "../../utils/Smartsupp";

const styles = (theme) => ({
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
    width: 180,
    height: "100vh",
    position: "fixed",
    left: 0,
    top: 0,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "auto",
      position: "fixed",
      bottom: "auto",
      top: 0,
      left: 0,
      zIndex: 1200,
    },
  },
  drawer: {
    width: 180,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: 180,
      boxSizing: "border-box",
      backgroundColor: theme.palette.darkGrey.main,
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        height: "auto",
        position: "fixed",
        bottom: "auto",
        top: 0,
      },
    },
  },
  toolbar: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(0),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      height: "auto",
      padding: theme.spacing(1),
      justifyContent: "space-around",
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    },
  },
  mainContent: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "center",
      height: "56px",
    },
  },
  title: {
    marginBottom: theme.spacing(4),
    fontWeight: 600,
    color: "white",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  link: {
    textDecoration: "none",
    width: "100%",
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    color: "white",
    padding: "8px 16px",
    position: "relative",
    [theme.breakpoints.down("xs")]: {
      width: "auto",
      marginBottom: 0,
      padding: "8px",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
    "&.active": {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        height: "60%",
        width: 3,
        backgroundColor: theme.palette.orange.main,
        borderTopRightRadius: 3,
        borderBottomRightRadius: 3,
        [theme.breakpoints.down("xs")]: {
          left: "50%",
          top: "auto",
          bottom: 0,
          transform: "translateX(-50%)",
          height: 3,
          width: "60%",
        },
      },
      "& $icon": {
        color: theme.palette.orange.main,
        opacity: 1,
      },
    },
  },
  iconText: {
    textTransform: "none",
    fontSize: "14px",
    color: "white",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: 0,
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      justifyContent: "center",
      marginTop: 0,
    },
  },
  icon: {
    fontSize: "20px !important",
    marginRight: theme.spacing(1),
    opacity: 0.7,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  cardMedia: {
    height: 50,
    width: 50,
  },
  homeIcon: {
    marginBottom: theme.spacing(4),
    marginTop: 22,
    display: "flex",
    justifyContent: "center",
    width: "100%",
    "& .MuiIconButton-root": {
      padding: 0,
      margin: 0,
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 0,
    },
  },
  desktopButtons: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      justifyContent: "space-around",
      height: "100%",
    },
  },
  logoutButton: {
    marginTop: "auto",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      marginTop: 0,
      width: "auto",
    },
  },
  mobileMenuButton: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
      position: "fixed",
      top: theme.spacing(2),
      left: theme.spacing(2),
      zIndex: 1200,
    },
  },
});

class MainAppBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileOpen: false,
    };

    this.logout = this.logout.bind(this);
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
  }

  logout() {
    localStorage.setItem("token", null);
    ApiUser.logout();
  }

  handleDrawerToggle() {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  }

  isActive = (path) => {
    const { location } = this.props;
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  render() {
    const { classes, location } = this.props;
    const { mobileOpen } = this.state;
    const { t } = this.props;
    const userLanguage = this.props.i18n.language;
    const isFr = userLanguage.startsWith("fr");

    const drawer = (
      <div className={classes.toolbar}>
        <Link to="/" className={classes.homeIcon}>
          <IconButton aria-label="accueil" edge="end" color="secondary">
            <Card>
              <CardMedia
                className={classes.cardMedia}
                component="img"
                alt="Logo"
                height="60"
                width="60"
                image="/logo192.png"
                title="Logo"
              />
            </Card>
          </IconButton>
        </Link>

        <div className={classes.mainContent}>
          <div className={classes.desktopButtons}>
            <Link
              to="/"
              className={`${classes.link} ${this.isActive("/") ? "active" : ""
                }`}
            >
              <Button className={classes.iconText}>
                <HomeIcon className={classes.icon} />
                {t("navigation.tours")}
              </Button>
            </Link>
            <Link
              to="/user/account"
              className={`${classes.link} ${this.isActive("/user/account") ? "active" : ""
                }`}
            >
              <Button className={classes.iconText}>
                <AccountIcon2 className={classes.icon} />
                {t("navigation.account")}
              </Button>
            </Link>
            <Link
              to="/statistiques-globales"
              className={`${classes.link} ${this.isActive("/statistiques-globales") ? "active" : ""
                }`}
            >
              <Button className={classes.iconText}>
                <BarChartIcon className={classes.icon} />
                {t("statistics.title")}
              </Button>
            </Link>
            <Link
              to="/boutique"
              className={`${classes.link} ${this.isActive("/boutique") ? "active" : ""}`}
            >
              <Button className={classes.iconText}>
                <StorefrontIcon className={classes.icon} />
                {t("navigation.boutique")}
              </Button>
            </Link>
            {this.props.showAdminButton && (
              <Link
                to="/admin/manage-accounts"
                className={`${classes.link} ${this.isActive("/admin") ? "active" : ""
                  }`}
              >
                <Button className={classes.iconText}>
                  <SupervisorAccount className={classes.icon} />
                  {t("navigation.clients")}
                </Button>
              </Link>
            )}
            {/* <a
              href={
                isFr
                  ? "https://landingzone.app/aide/"
                  : "https://landingzone.app/online-help/"
              }
              target="_blank"
              className={classes.link}
            >
              <Button className={classes.iconText}>
                <HelpIcon className={classes.icon} />
                {t("navigation.help")}
              </Button>
            </a> */}
          </div>

          <Link
            to="/login"
            className={`${classes.link} ${classes.logoutButton}`}
            onClick={this.logout}
          >
            <Button className={classes.iconText}>
              <ExitToApp className={classes.icon} />
              {t("navigation.logout")}
            </Button>
          </Link>
        </div>
      </div>
    );

    return (
      <>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={this.handleDrawerToggle}
          className={classes.mobileMenuButton}
        >
          <MenuIcon />
        </IconButton>
        <Drawer
          variant="permanent"
          className={classes.drawer}
          classes={{
            paper: classes.drawer,
          }}
        >
          {drawer}
        </Drawer>
        <SmartsuppChat user={this.props.user} isFr={this.props.isFr} />
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(withTranslation()(MainAppBar))
);
